import { CHK_PREFIX } from "../rhf-mui/RhfCheckGroup";

/** "AAA﹋BBB﹋CCC" --> ["AAA","BBB","CCC"] */
export function StringToOptions(opt_field: string): string[] {
  if (opt_field != null && opt_field !== "") {
    return opt_field.split('﹋');
  } else {
    return [];
  }
}

/** ["AAA","BBB","CCC"] --> "AAA﹋BBB﹋CCC" */
export function OptionsToString(opt_list: string[]): string {
  if (opt_list.length !== 0) {
    return opt_list.join('﹋');
  } else {
    return "";
  }
}


/**
 * 將 opt_field 的數值 寫入介面(inputs_kv_map)  
 * 視情況會補上 chk_ 前綴
 * @param inputs_kv_map rhf介面資料格式: {"chk_選項A": true, "chk_選項B": false, "chk_選項C": true, }
 * @param opt_field 要載入的資料庫內容 "選項A﹋選項C"
 * @param chk_prefix 是否要加上或移除前綴 "chk_"
*/
export function RhfLoadChecks(inputs_kv_map: { [key: string]: boolean }, opt_field: string, chk_prefix?: string) {

  if (inputs_kv_map == null) {
    inputs_kv_map = {};
  }

  //#region 解析 資料庫 opt 欄位 "["選項A", "選項B", "選項X"]"
  let opt_list: string[] = StringToOptions(opt_field);
  //#endregion

  //#region 判斷是否加入 chk_ 前綴，並將資料庫的選項都加上 chk_
  chk_prefix = (chk_prefix == null ? CHK_PREFIX : chk_prefix);
  opt_list.forEach((opt, index) => {
    opt_list[index] = chk_prefix + opt;// 補上 chk_ 開頭
  });
  //#endregion

  //#region 清空介面上的欄位
  for (const key in inputs_kv_map) {
    inputs_kv_map[key] = false;
  }
  //#endregion

  //#region 打勾介面上的欄位 (如果資料庫有這個項目)
  for (const opt of opt_list) {
    inputs_kv_map[opt] = true;
  }
  //#endregion

  return inputs_kv_map;
}

/**
 * 回傳 inputs_kv_map 寫入欄位後的字串  
 * old_opt_field 不在畫面上的選項不會被覆蓋
 * 並且會視情況 加入或移除 chk_ 開頭
 * @param inputs_kv_map rhf介面資料格式: {"chk_選項A": true, "chk_選項B": false, "chk_選項C": true, }
 * @param old_opt_field 修改前的欄位內容 "選項A﹋選項C"
 * @param chk_prefix 是否要加上或移除前綴 "chk_"
 */
export function RhfSaveChecks(inputs_kv_map: { [key: string]: boolean }, old_opt_field: string, chk_prefix?: string): string {

  //#region 解析 資料庫 opt 欄位 "["選項A", "選項B", "選項X"]"
  let opt_list: string[] = StringToOptions(old_opt_field);
  //#endregion

  //#region 判斷是否有 chk_ 前綴
  chk_prefix = (chk_prefix == null ? CHK_PREFIX : chk_prefix);
  const chk_prefix_len = chk_prefix.length;
  //#endregion

  //#region 將資料庫中的選項都加上 chk_ 前綴 (比對過程中使用，最後再移除)
  opt_list.forEach((opt, index) => {
    opt_list[index] = chk_prefix + opt;// 補上 chk_ 開頭
  });
  //#endregion

  for (const key in inputs_kv_map) {
    let tf = inputs_kv_map[key];

    if (tf === true) {// 如果 key 不存在，則加入
      if (opt_list.includes(key) === false) {
        opt_list.push(key);// 加入至陣列
      } else {
        // pass; 原本已存在 key --> 不動作
      }
    } else {
      if (opt_list.includes(key) === true) {
        opt_list = opt_list.filter(x => x !== key);// 從陣列移除
      } else {
        // pass; 原本就沒有 --> 不動作
      }
    }
  }

  //#region 實際儲存在資料庫不需要 chk_ 前綴(自動移除)
  opt_list.forEach((opt, index) => {
    opt_list[index] = opt.substring(chk_prefix_len);// 移除 chk_ 開頭
  });
  //#endregion

  return OptionsToString(opt_list);
}



// https://stackoverflow.com/questions/650022/how-do-i-split-a-string-with-multiple-separators-in-javascript
// 不確定 token 如果不是 char 而是 string 的效果(待驗證)
export function SplitMulti(str: string, tokens: string[]) {
  var tempChar = tokens[0]; // We can use the first token as a temporary join character

  for (var i = 1; i < tokens.length; i++) {
    str = str.split(tokens[i]).join(tempChar);
  }

  return str.split(tempChar);
}

// https://stackoverflow.com/questions/26156292/trim-specific-character-from-a-string
// 不確定 token 如果不是 char 而是 string 的效果(待驗證)
export function TrimAny(str: string, chars: string[]) {
  var start = 0,
    end = str.length;

  while (start < end && chars.indexOf(str[start]) >= 0)
    ++start;

  while (end > start && chars.indexOf(str[end - 1]) >= 0)
    --end;

  return (start > 0 || end < str.length) ? str.substring(start, end) : str;
}
